import { Theme } from '@mui/material/styles'

const muiChip = (theme: Theme) => {
  return {
    styleOverrides: {
      deleteIcon: {
        color: 'inherit',
        '&:hover': {
          color: 'inherit'
        }
      },
      root: {
        padding: '0.25rem 0rem',
        fontSize: '0.75rem',
        border: 'none',
        '&.MuiChip-colorDefault': {
          color: theme.colors.default,
          background: theme.colors.subHover
        },
        '& .MuiAvatar-root ': {
          color: theme.palette.primary.contrastText,
          background: theme.palette.primary.main,
          borderRadius: 6,
          fontSize: '0.75rem'
        }
      },
      sizeSmall: {
        borderRadius: 6,
        height: '1.5rem'
      },
      sizeMedium: {
        borderRadius: 8,
        height: '2rem'
      },
      colorInfo: {
        background: theme.palette.info.light,
        color: theme.palette.info.main
      },
      colorSuccess: {
        background: theme.palette.success.light,
        color: theme.palette.success.main
      },
      colorError: {
        background: theme.palette.error.light,
        color: theme.palette.error.main
      },
      colorWarning: {
        background: theme.palette.warning.light,
        color: theme.palette.warning.main
      }
    }
  }
}

export default muiChip
